import { Badge } from "@/components/shadcn/badge";

const chessTitleColors = {
    GM: "bg-gm",
    WGM: "bg-gm",
    IM: "bg-im",
    WIM: "bg-im",
    FM: "bg-fm",
    WFM: "bg-fm",
    CM: "bg-cm",
    WCM: "bg-cm",
    NM: "bg-nm",
    WNM: "bg-nm",
} as const;

export type ChessTitleValue = keyof typeof chessTitleColors;

type ChessTitleProps = {
    title: ChessTitleValue;
};

export function parseChessTitle(
    title: string | null | undefined,
): ChessTitleValue | null {
    const normalizedTitle = title?.toUpperCase();

    return normalizedTitle && Object.hasOwn(chessTitleColors, normalizedTitle)
        ? (normalizedTitle as ChessTitleValue)
        : null;
}

export default function ChessTitle({ title }: ChessTitleProps) {
    return (
        <Badge
            className={`${chessTitleColors[title]} text-chess-title-foreground`}
        >
            {title}
        </Badge>
    );
}
